import PrettyNum from '@ebiz/pretty-num';
import Utils from './utils';

/**
 * Wrapper for the ebiz pretty-num library
 */
export default {
    lessThan(prettyValue1, prettyValue2) {
        return this.userEntryToNumber(prettyValue1) < this.userEntryToNumber(prettyValue2);
    },

    greaterThan(prettyValue1, prettyValue2) {
        return this.userEntryToNumber(prettyValue1) > this.userEntryToNumber(prettyValue2);
    },

    equalTo(prettyValue1, prettyValue2) {
        return this.userEntryToNumber(prettyValue1) === this.userEntryToNumber(prettyValue2);
    },

    lessThanEqualTo(prettyValue1, prettyValue2) {
        return this.userEntryToNumber(prettyValue1) <= this.userEntryToNumber(prettyValue2);
    },

    greaterThanEqualTo(prettyValue1, prettyValue2) {
        return this.userEntryToNumber(prettyValue1) >= this.userEntryToNumber(prettyValue2);
    },

    userEntryToNumber(textFromUser) {
        return PrettyNum.userEntryToNumber(textFromUser.toString(), NaN);
    },

    //Shorthand function for numberToUserDisplay
    //Engineering notation, 3 significant digits, don't show extra zeroes
    eng3(number, inOptions) {
        return this.eng(number, 3, inOptions);
    },

    //Shorthand function for numberToUserDisplay
    //Engineering notation, 4 significant digits, don't show extra zeroes
    eng4(number, inOptions) {
        return this.eng(number, 4, inOptions);
    },

    eng(number, defaultDigits, inOptions = {}) {
        let options = {},
            digits = defaultDigits;

        if (number === '') return '';

        if (Utils.isNumeric(inOptions.scale)) {
            options.fixedDigits = true;
            digits = inOptions.scale;
        }

        if (inOptions.separatedUnit) options.supplySpace = true;

        return PrettyNum.numberToUserDisplay(number, 'Engineering', digits, options);
    },

    spice(number, digits = 3) {
        return PrettyNum.numberToUserDisplay(number, 'Spice', digits);
    },

    roundToNs(number) {
        let result = undefined,
            options = { fixedDigits: false, minMetricPrefix: 'n' };
        try {
            result = PrettyNum.numberToUserDisplay(number, 'Engineering', 3, options);
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            console.warn(`Could not convert time axis value to ns (${number})`);
            result = 0;
        }

        return result;
    },
};
